// extracted by mini-css-extract-plugin
export var DM = "NavigationVenue-module--DM--b8dd8";
export var MAG = "NavigationVenue-module--MAG--ed3b6";
export var MOM = "NavigationVenue-module--MOM--ae23e";
export var NavigationVenue = "NavigationVenue-module--NavigationVenue--e9397";
export var PH = "NavigationVenue-module--PH--7bafe";
export var isCurrent = "NavigationVenue-module--isCurrent--bebaf";